// Runtime binds functions created by application code. HTML never contains JS source.
const UIEvents = (() => {
    const entries=new Map(), bound=new WeakMap();
    const allowed=new Set(['click','dblclick','change','input','submit','keydown','keyup','keypress','focus','blur','mouseover','mouseout','mouseenter','mouseleave','mousedown','mouseup','error','load','loadedmetadata','dragstart','dragend','dragover','dragleave','dragenter','drop','scroll','contextmenu','touchstart','touchend']);
    function attr(type,handler,captured=[]){
        if(!allowed.has(type)||typeof handler!=='function')throw new TypeError('UI event requires an allowed type and a function');
        const token=crypto.randomUUID();
        entries.set(token,{type,handler,captured,created:Date.now()});
        return 'data-sicaf-event-'+type+'="'+token+'"';
    }
    function mount(root){
        if(!root)return;
        const nodes=[...(root.nodeType===1?[root]:[]),...(root.querySelectorAll?.('*')||[])];
        for(const node of nodes){
            for(const attribute of Array.from(node.attributes||[])){
                if(!attribute.name.startsWith('data-sicaf-event-'))continue;
                const token=attribute.value,entry=entries.get(token);
                if(!entry||attribute.name!=='data-sicaf-event-'+entry.type){node.removeAttribute(attribute.name);continue;}
                let set=bound.get(node);if(!set){set=new Set();bound.set(node,set);}
                if(set.has(token))continue;
                const handler=entry.handler || entry.ref?.deref();
                if(!handler){node.removeAttribute(attribute.name);continue;}
                const captured=entry.captured;
                const listener=function(event){
                    const result=handler.call(this,event,captured);
                    if(result===false)event.preventDefault();
                    if(result?.catch)result.catch(error=>{console.error('UI action failed',error);if(typeof Utils!=='undefined')Utils.showToast('No se pudo completar la acción. Vuelve a intentarlo.','error');});
                };
                node.addEventListener(entry.type,listener,{once:entry.type==='error'});set.add(token);
                // The mounted listener owns the function; detached views can be collected.
                entry.ref=new WeakRef(handler);delete entry.handler;
            }
        }
    }
    function sweep(){
        const now=Date.now();
        for(const [token,entry] of entries)if((entry.ref&&!entry.ref.deref())||(!entry.ref&&now-entry.created>60000))entries.delete(token);
    }
    if(typeof document!=='undefined'&&typeof MutationObserver!=='undefined'){
        const observer=new MutationObserver(records=>{for(const record of records)for(const node of record.addedNodes)mount(node);});
        observer.observe(document,{childList:true,subtree:true});
        document.addEventListener('DOMContentLoaded',()=>mount(document),{once:true});
        setInterval(sweep,30000);
    }
    return {attr,mount,sweep};
})();
if(typeof window!=='undefined')window.UIEvents=UIEvents;
if(typeof module!=='undefined'&&module.exports)module.exports=UIEvents;
